export enum ERROR_KEYS {
  GUEST_MODE = 'guestMode',
  INVALID_VIN = 'invalidVin',
  CANNOT_LOAD = 'cannotLoad',
  RECALL_CAMPAIGN_ERROR = 'requestFailed'
}
export const BFF_ERROR_VALUES={
  ERROR_KEY_VALUES: [
     { 
      CODE : '',
      DESCRIPTION : 'UI.Unable.To.Retrieve.Data.From.BFF.PDP.Pricing.API.For.Unknown.Reasons'
     },
     { 
      CODE : 'OC-BFF-PRC002-ENR001',
      DESCRIPTION : 'BFF.PDP.Pricing.API.Failure.From.Service.Sales.Offer.Retail.Account.Not.Migrated.For.Requested.Account.OFFERS'
     },
     { 
      CODE : 'OC-BFF-PRC002-ENR002',
      DESCRIPTION : 'BFF.PDP.Pricing.API.Failure.From.Service.Sales.Offer.Retail.Channel.Is.Not.Supported.OFFERS'
     },
     { 
      CODE : 'OC-BFF-PRC002-ENR004',
      DESCRIPTION : 'BFF.PDP.Pricing.API.Failure.From.Service.Sales.Offer.Retail.No.Offers.Found.OFFERS'
     },
     { 
      CODE : 'OC-BFF-PRC002-ENR005',
      DESCRIPTION : 'BFF.PDP.Pricing.API.Failure.From.Service.Sales.Offer.Retail.Vehicle.Not.Found.For.This.Account.OFFERS'
     },
     { 
      CODE : 'OC-BFF-PRC002-ENR006',
      DESCRIPTION : 'BFF.PDP.Pricing.API.Failure.From.Service.Sales.Offer.Retail.Policy.Not.Found.OFFERS'
     },
     { 
      CODE : 'OC-BFF-PRC003-OCBF010',
      DESCRIPTION : 'BFF.PDP.Pricing.API.Failure.From.Service.Sales.Offer.Retail.Unregognized.Field.OFFERS'
     },
     { 
      CODE : 'OC-BFF-PRC003-OCBF006',
      DESCRIPTION : 'BFF.PDP.Pricing.API.Failure.From.Service.Sales.Offer.Retail.500.Internal.Server.Error.OFFERS'
     },
     { 
      CODE : 'OC-BFF-PRC001-OCBF004',
      DESCRIPTION : 'BFF.PDP.Pricing.API.Failure.From.Service.Sales.Offer.Retail.No.Offers.Found.Received.Empty.Response.From.Sales.Offer.Retail.OCBF'
     },
     { 
      CODE : 'OC-BFF-PRC004-ORD0027',
      DESCRIPTION : 'BFF.PDP.Pricing.API.Failure.From.Service.GetOrder.Error.With.SIL.Payment.SIL'
     },
     { 
      CODE : 'OC-BFF-PRC005-ORD0028',
      DESCRIPTION : 'BFF.PDP.Pricing.API.Failure.From.Service.GetOrder.Error.With.SIL.Account.Subscription.SIL'
     },
     { 
      CODE : 'OC-BFF-PRC008-ORD008',
      DESCRIPTION : 'BFF.PDP.Pricing.API.Failure.From.Service.GetOrder.Policy.Not.Found.ORDERS'
     },
     { 
      CODE : 'OC-BFF-PRC006-ORD013',
      DESCRIPTION : 'BFF.PDP.Pricing.API.Failure.From.Service.GetOrder.GAA.Service.Unavailable.GAA'
     },
     { 
      CODE : 'OC-BFF-PRC007-ORD014',
      DESCRIPTION : 'BFF.PDP.Pricing.API.Failure.From.Service.GetOrder.Error.Occurred.In.GAA.Order.Creation.GAA'
     },
     { 
      CODE : 'OC-BFF-PRC008-ORD019',
      DESCRIPTION : 'BFF.PDP.Pricing.API.Failure.From.Service.GetOrder.Error.Occurred.In.CVC.Order.Creation.OFFERS'
     },
     { 
      CODE : 'OC-BFF-PRC009-ORD009',
      DESCRIPTION : 'BFF.PDP.Pricing.API.Failure.From.Service.GetOrder.Error.Occurred.In.Order.Creation.ORDERS'
     },
     { 
      CODE : 'OC-BFF-PRC003-ORD010',
      DESCRIPTION : 'BFF.PDP.Pricing.API.Failure.From.Service.GetOrder.Unrecognized.Field.ORDER'
     },
     { 
      CODE : 'OC-BFF-PRC011-ORD006',
      DESCRIPTION : 'BFF.PDP.Pricing.API.Failure.From.Service.GetOrder.500.Internal.Service.Error.ORDERS'
     },
     { 
      CODE : 'OC-BFF-PRC003-ORD003',
      DESCRIPTION : 'BFF.PDP.Pricing.API.Failure.From.Service.GetOrder.Error.In.Order.Processing.ORDERS'
     }
    ]
 };
